import { ExclamationMarkCircleFilled } from "components/icons/generated";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import Typography from "ds/components/Typography";

type DriftDetectedCellProps = {
  drifted: boolean;
};

const DriftDetectedCell = ({ drifted }: DriftDetectedCellProps) => {
  if (!drifted) {
    return (
      <Typography tag="span" variant="p-body3" color="secondary">
        -
      </Typography>
    );
  }

  return (
    <Box align="center" gap="small">
      <Icon src={ExclamationMarkCircleFilled} color="danger" noShrink />
      <Typography tag="span" variant="p-body3" color="secondary">
        Yes
      </Typography>
    </Box>
  );
};

export default DriftDetectedCell;
